<template>
  <div>
    <v-app-bar height="70px;" style="z-index: 10" clipped-left app color="#011b42">
      <v-btn @click="changeDrawer" style="margin-left: 0px; margin-right: 15px" text small fab color="white">
        <v-icon>dehaze</v-icon>
      </v-btn>
      <div v-on:click="redirectToDashboard">
        <img
          style="cursor: pointer; margin-left: -15px; margin-top: 10px; width: 220px; height: 80px"
          src="../../assets/CemiCloud.png"
        />
      </div>
      <v-btn
        style="margin-left: 50px"
        dark
        v-if="carregandoDadosOwner"
        large
        icon
        disabled
        :loading="carregandoDadosOwner"
      >
        <v-icon>mdi-cached</v-icon>
      </v-btn>
      <h2 style="color: white; margin-left: 50px">{{ owner.toUpperCase() }}</h2>

      <v-spacer />

      <!--      <div v-if="logo_url">-->
      <!--        <img style="margin-right: 20px;object-fit: contain;height: 50px;margin-top: 5px;" :src="logo_url"/>-->
      <!--      </div>-->

      <v-btn
        style="margin-right: 50px"
        dark
        v-if="carregandoDadosOwner"
        large
        icon
        disabled
        :loading="carregandoDadosOwner"
      >
        <v-icon>mdi-cached</v-icon>
      </v-btn>
      <v-overflow-btn
        v-if="showChangeOwner()"
        v-model="ownerSelecionado"
        :items="owners"
        item-text="nome"
        item-value="cdOwner"
        menu-props="auto"
        label="Select"
        hide-details
        prepend-icon="mdi-map-marker-radius"
        single-line
        solo
        dark
        editable
        background-color="#011b42"
        style="max-width: 270px"
        @change="updateToken"
      ></v-overflow-btn>

      <v-badge class="mx-8" :content="notificacoes" :value="notificacoes" color="red darken-1" overlap>
        <v-icon @click="abrirNotificacoes()" color="white">mdi-bell</v-icon>
      </v-badge>

      <v-menu v-if="!carregandoDadosOwner" close-on-click close-on-content-click offset-y>
        <template v-slot:activator="{ on }">
          <v-btn depressed text color="white" v-on="on">
            <v-icon left>person</v-icon>
            {{ username }}
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item v-for="(item, index) in items" :key="index" @click="item.action">
            <v-list-item-title>
              <v-icon left :color="item.color">{{ item.icon }}</v-icon>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
  </div>
</template>

<script>
import OwnerService from "@/service/v3/OwnerService";
import UsuarioService from "@/service/UsuarioService";
import loginService from "../../service/LoginService";
import NotificacaoWebService from "@/service/NotificacaoWebService";
import { EventBus } from "../../EventBus";

export default {
  data() {
    return {
      notificacoes: null,
      pollingInterval: null,

      ownerSelecionado: null,
      currentOwner: null,
      owners: [],
      carregandoDadosOwner: false,
      username: "",
      owner: "",
      logo_url: "",
      perfis: [],

      items: [
        {
          title: "Perfil",
          icon: "person_outline",
          color: "blue",
          action: this.perfil,
        },
        {
          title: "Chamados",
          icon: "mdi-phone-outline",
          color: "green",
          action: this.chamados
        },
        {
          title: "Sair",
          icon: "power_settings_new",
          color: "red",
          action: this.logout,
        },
      ],
      registerItems: [{ title: "Pessoas", icon: "person", color: "grey", action: this.sair }],
    };
  },
  methods: {
    async carregarNotificacoes() {
      try {
        this.notificacoes = await NotificacaoWebService.getQuantidadeNotificacoesNaoLidas();
        this.notificacoes = this.notificacoes.data.quantidade;
      } catch (error) {
        console.error(error);
      }
    },

    updateToken() {
      if (this.ownerSelecionado && this.currentOwner != this.ownerSelecionado) {
        UsuarioService.changeOwner(this.ownerSelecionado).then(() => {
          window.location.href = "/";
        });
      }
    },
    searchOwners() {
      OwnerService.getAll().then(({ data }) => {
        this.owners = data;
      });
    },
    showChangeOwner() {
      return this.perfis.includes("CEMICLOUD");
    },
    changeDrawer() {
      this.$store.dispatch("General/changeMinivariantStatus");
    },
    abrirNotificacoes() {
      if (this.$route.path !== "/notificacoes") this.$router.push("/notificacoes");
    },
    logout() {
      loginService.logout();
    },
    redirectToDashboard() {
      this.$router.push("/dashboard");
    },
    perfil() {
      this.$router.push("/perfil");
    },
    chamados() {
      this.$router.push("/chamados");
    },
  },
  async created() {
    // this.pollingInterval = setInterval(this.carregarNotificacoes, 20000);
    this.carregarNotificacoes();

    this.searchOwners();
    this.carregandoDadosOwner = true;

    this.$store.dispatch("Login/getUser").then((response) => {
      this.ownerSelecionado = response.owner.cdOwner;
      this.currentOwner = response.owner.cdOwner;
      this.perfis = response.roles;
      this.username = response.nome;
      this.owner = response.owner.nome;
      this.logo_url = response.owner.logoUrl;
      this.carregandoDadosOwner = false;
    });

    EventBus.$on("carregarNotificacoes", this.carregarNotificacoes);
  },
  beforeDestroy() {
    EventBus.$off("carregarNotificacoes", this.carregarNotificacoes);
  },
};
</script>
